import { z } from 'zod/v4'
import { ThreadCreateCommandSchema } from './commands/thread.create.schema'
import { ThreadGetCommandSchema } from './commands/thread.get.schema'
import { ThreadGetParticipantCommandSchema } from './commands/thread.get-participant.schema'
import { ThreadMessageSendCommandSchema } from './commands/thread.message.send.schema'
import { ThreadSignalCreateCommandSchema } from './commands/thread.signal.create.schema'
import { ThreadResolveCommandSchema } from './commands/thread.resolve.schema'

// Threads service schema
export const ThreadsServiceSchema = z.union([
  ThreadCreateCommandSchema,
  ThreadGetCommandSchema,
  ThreadGetParticipantCommandSchema,
  ThreadMessageSendCommandSchema,
  ThreadSignalCreateCommandSchema,
  ThreadResolveCommandSchema,
])

// Threads service types
export type ThreadsService = z.infer<typeof ThreadsServiceSchema>
